import React, { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { apiUrlImg } from "../../Routes/api/global_vars";

export const ServiceDropdown = ({
  category,
  selectedService,
  onServiceSelect,
  isActive,
  selectedServiceImg
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const services = category &&
    category?.services.filter((service) =>
      service.sous_services.some((ss) => ss.projets?.length > 0)
    ) || [];

  const displayText = selectedService || category.nom_categorie;
  // console.log(selectedServiceImg);
  
  return (
    <div className=" h-max" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className={`flex items-center justify-between text-sm px-3 shadow-sm h-14 rounded-xl transition-colors ${
          isActive
            ? selectedService
              ? "bg-orange text-white "
              : "bg-gray-200 text-gray-800/50"
          : "bg-white text-gray-800/80"
        }`}
      >
        <div className="bg-white rounded-full p-2 me-2">
          <img src={`${apiUrlImg}/${category?.image}`} alt="image-category" className="w-6 h-6" />
        </div>
        <span className="truncate text-[16px] font-semibold font-inter mr-2">{displayText}</span>
        <ChevronDown
          className={`w-4 h-4 transition-transform ${
            isOpen ? "transform rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && services.length > 0 && (
        <div className=" w-auto mt-1 bg-white py-3 border-gray-300 rounded-xl shadow-lg">
          {services.map((service) => (
            <div
              key={service.id}
              className="px-4 py-2 text-nowrap hover:bg-gray-200 text-sm cursor-pointer"
              onClick={() => {
                onServiceSelect(service);
                setIsOpen(false);
              }}
            >
              {service.nom_service}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


// Le bouton de filtre 

export const FilterButton = ({ label, onClick, selected }) => {
  return (
    <button
      className={`px-2 py-2 text-[10px] rounded-xl text-nowrap ${
        label === "Tous les projets" &&
        "h-14 px-4 font-semibold bg-white shadow-sm font-inter text-[16px] text-gray-800"
      } ${
        selected
          ? "!bg-orange text-white "
          : `bg-[#066AC91A] text-[#066AC9] ${
              label === "Tous les projets" && "!bg-gray-white !text-gray-800"
            }`
      }`}
      onClick={() => onClick(label)}
    >
      {label}
    </button>
  );
};
